import React, { useEffect, useState } from 'react'
import '../Style/Comment.css'
import CalenderIcon from '../Logos/calendar.svg'
import axios from 'axios'
import ProfilePicture from '../Profile_Pictures/1662741205554.jpg'

function Comment_Component(Comment_Data) {
    const [UserID, SetID] = useState(Comment_Data.Comment_Data.user_id)
    const [CommentDate, SetCommentDate] = useState(Comment_Data.Comment_Data.date)
    const [Comment, SetComment] = useState(Comment_Data.Comment_Data.comment)

    const [UserData, SetUserData] = useState()
    axios.post("http://127.0.0.1:3001/get-comment-user-info", { UserID })
        .then(data => {
            SetUserData(data.data)
        })
        .catch(err => {console.log(err)})
    // useEffect(() => {
    //     axios.post("http://127.0.0.1:3001/get-comment-user-info", { UserID })
    //     .then(data => {
    //         SetUserData(data.data)
    //     })
    //     .catch(err => {console.log(err)})
    // }, [])
    return (
        <>
            <div className='comment'>
                <div className='userprofile-container'>
                    <div className='username-and-date'>
                        <div className='username'>{UserData? UserData.Username: null}</div>
                        <div className='comment-date'>
                            <div className='text'>{CommentDate}</div>
                            <img src={CalenderIcon} className='calender-icon' />
                        </div>
                    </div>
                    <div className='userprofile' style={{ backgroundImage: `url(${ProfilePicture})` }}></div>
                </div>
                <div className='comment-description'>{Comment}</div>
            </div>
        </>
    )
}

export default Comment_Component